import Vue from 'vue'
import axios from 'axios'
import store from './../store'
import router from './../router'
import toastr from 'toastr'

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
axios.defaults.baseURL = process.env.VUE_APP_API_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['Authorization'] = token
  store.dispatch('SET_AUTHENTICATED', true)
} else {
  store.dispatch('SET_AUTHENTICATED', false)
}

axios.interceptors.request.use((config) => {
  store.dispatch('SET_LOADING', true)
  return config
}, (error) => {
  return Promise.reject(error);
})

axios.interceptors.response.use((response) => {
  store.dispatch('SET_LOADING', false)
  return response
}, function (error) {
  const status = error.response.status
  const data = error.response.data
    if (status === 401) {
    toastr.error(data.message, window.TITLE_ERROR)
    axios.defaults.headers.common['Authorization'] = ''
    store.dispatch('SET_AUTHENTICATED', false)
    localStorage.clear()
    router.push({ name: 'Login' })
  } else if (status === 422) {
    const validationErrors = data.errors
    for (let key in validationErrors) {
      const error = validationErrors[key]
      toastr.error(error[0], window.TITLE_ERROR)
    }
  } else if (status === 403) {
    if (data.hasOwnProperty('message')) {
      toastr.error(data.message, window.TITLE_ERROR)
    }
  } else if (status === 404) {
    if (data.hasOwnProperty('message')) {
      toastr.error(data.message, window.TITLE_ERROR)
    }
  } else if (status === 500) {
    if (data.hasOwnProperty('message')) {
      toastr.error(data.message, window.TITLE_ERROR)
    }
  }
  store.dispatch('SET_LOADING', false)
  return Promise.reject(error)
  })

Vue.prototype.$axios = axios
